var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoLastPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49105 21.6247L17.811 14.3047C18.601 13.7947 19.071 12.9347 19.071 11.9947C19.071 11.0547 18.601 10.1947 17.811 9.68469L6.49105 2.36469C5.63105 1.80469 4.58105 1.76469 3.68105 2.25469C2.78105 2.74469 2.24105 3.64469 2.24105 4.67469L2.24105 19.3247C2.24105 20.3447 2.78105 21.2547 3.68105 21.7447C4.58105 22.2347 5.63104 22.1947 6.49105 21.6347L6.49105 21.6247Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.2112,
    y: 22.0859,
    width: 2.0603,
    height: 20.1716,
    rx: 1.03015,
    transform: "rotate(-180 22.2112 22.0859)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoLastPage);
export default __webpack_public_path__ + "static/media/go_last_page.44ead95d48c886890d5ddd6af4bacbfa.svg";
export { ForwardRef as ReactComponent };